// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"ie_a bhb_je","CommentListPlaceholder--Legacy":"ie_b bhb_qh bhb_vk"};